<template>
  <div class="login">
    <div class="dialog">
      <div class="title">登录</div>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="form">
        <el-form-item prop="username">
          <el-input v-model="ruleForm.username" placeholder="账号" class="username"
            @keyup.enter.native="submitForm('ruleForm')"></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input v-model="ruleForm.password" placeholder="密码" show-password class="password"
            @keyup.enter.native="submitForm('ruleForm')"></el-input>
        </el-form-item>
      </el-form>
      <el-button type="primary" @click="submitForm('ruleForm')" :loading="loading">登录</el-button>
    </div>

    <!-- 强制更新弹窗 -->
    <el-dialog title="版本更新提示" :visible.sync="forceUpdateVisible" :close-on-click-modal="false"
      :close-on-press-escape="false" :show-close="false" :before-close="() => { }" width="400px" center>
      <div style="text-align: center; padding: 20px 0;">
        <i class="el-icon-warning" style="font-size: 48px; color: #E6A23C; margin-bottom: 20px;"></i>
        <p style="font-size: 16px; line-height: 1.6; margin-bottom: 20px;">
          检测到新版本 <strong>{{ serverVersion }}</strong>，当前版本为 <strong>{{ version }}</strong>
        </p>
        <p style="font-size: 14px; color: #666; margin-bottom: 30px;">
          必须下载最新版本才能继续使用(最新服务端下载地址：https://xoaoss001.yyaiya.com/apk/pdServer-dev-5.5.5.zip)
        </p>
        <el-button type="primary" size="large" @click="forceDownload" style="padding: 12px 40px; font-size: 16px;">
          立即下载
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import store from '@/store';
import request from '@/api/request';
import { getVersion, logout } from '@/api/user';
export default {
  components: {},
  data() {
    return {
      ruleForm: {
        username: '',
        // admin
        password: '',
        // chatspace
      },
      rules: {
        username: { required: true, message: '账号不能为空', trigger: 'blur' },
        password: { required: true, message: '密码不能为空', trigger: 'blur' },
      },
      loading: false,
      version: '5.5.5',
      forceUpdateVisible: null, // 强制更新弹窗显示状态
      serverVersion: '', // 服务端版本号
    };
  },
  computed: {},
  watch: {},
  methods: {
    // 检查服务端版本
    checkVersion() {
      getVersion().then(res => {
        console.log(res, '服务端版本信息');
        if (res.code === 200 && res.data) {
          const serverVersion = res.data.configValue;
          console.log('服务端版本:', serverVersion, '前端版本:', this.version);

          // 比较版本号
          if (serverVersion !== this.version) {
            this.serverVersion = serverVersion;
            this.forceUpdateVisible = true;
          } else {
            // 版本匹配，允许登录
            this.forceUpdateVisible = false;
          }
        }
      }).catch(err => {
        console.error('获取服务端版本失败:', err);
        // 用户没有启动本地服务
      });
    },

    // 强制下载
    forceDownload() {
      // 打开下载链接
      window.open('https://xoaoss001.yyaiya.com/apk/pdServer-dev-5.5.5.zip', '_blank');
      // 不关闭弹窗，保持显示状态
    },

    // 页面获得焦点时
    onWindowFocus() {
      // 如果版本不匹配且弹窗未显示，重新显示弹窗
      if (this.serverVersion && this.serverVersion !== this.version && !this.forceUpdateVisible) {
        this.forceUpdateVisible = true;
      }
    },

    // 页面失去焦点时
    onWindowBlur() {
      // 不做任何操作，保持弹窗状态
    },

    // 清空所有缓存和登录状态
    async clearAllCache() {
      // 检查是否有 token，如果有则先调用退出接口
      const token = localStorage.getItem('Admin-Token');
      if (token) {
        // 先调用退出接口
        await logout().catch(error => {
          // 如果调用失败（如未登录），忽略错误继续执行清空缓存
          console.log('退出接口调用失败（可能未登录）:', error);
        });
      }

      // 退出接口调用后再清空缓存
      localStorage.clear();
      
      // 清空 sessionStorage
      sessionStorage.clear();
      
      // 清空 Vuex store 中的用户信息
      this.$store.commit('SET_USER', { user: {}, roles: [], permissions: [] });
      
      // 清空 cookies（如果项目中有使用）
      document.cookie.split(";").forEach(function(c) { 
        document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); 
      });
      
      console.log('所有缓存已清空，用户需要重新登录');
    },
    submitForm1() {
      fetch('https://chatspace.lwvvl.com/talkytimes-api/platform/auth/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: '117826073@chnldx.com',
          password: 'Aa88888888',
          captcha: '',
          referral_code: '',
        }),
      })
        .then((response) => response.json())
        .then((res) => {
          console.log(res, 'res');
        })
        .catch((error) => {
          console.error('请求出错:', error);
        });
    },
    submitForm(formName) {
      // 如果版本检查还未完成，阻止登录
      if (this.forceUpdateVisible === null) {
        this.$message.warning('正在检查版本信息，请稍后...');
        return;
      }

      // console.log(formName, 'ruleForm')
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.loading = true;
          let data = await this.$store.dispatch('Login', this.ruleForm);
          //  这个值里含有登录平台信息的所有信息
          console.log(data, 'data');
          if (data.code == 200) {
            localStorage.removeItem('private'); // 移除私有登录标识
            this.$router.push('/talkytimes');
          } else {
            this.$message.error(data.msg);
          }
          this.loading = false;
        } else {
          this.loading = false;
        }
      });
    },
  },
  created() { },
  mounted() {
    // 清空所有缓存和登录状态
    this.clearAllCache();
    
    // 检查服务端版本
    this.checkVersion();

    // 监听页面焦点变化，确保从下载页面返回后弹窗仍然显示
    window.addEventListener('focus', this.onWindowFocus);
    window.addEventListener('blur', this.onWindowBlur);

    // 模拟向talkytimes平台发送请求
    // fetch('https://talkytimes.com/platform/auth/login-by-credential', {
    //     method: 'POST',
    //     headers: {
    //         'Content-Type': 'application/json'
    //     },
    //     body: JSON.stringify({
    //         "userId": 123,
    //         "username": "username",
    //         "password": "password123",
    //         "credential": "credential_string"
    //     })
    // })
    //     .then(response => response.json())
    //     .then(res => {
    //         console.log(res, 'res');
    //     })
    //     .catch(error => {
    //         console.error('请求出错:', error);
    //     });
    // fetch('https://talkytimes.com/platform/user/is-online', {
    //     method: 'POST',
    //     headers: {
    //         'Content-Type': 'application/json',
    //         'Authorization': 'Bearer ' + localStorage.getItem('token')
    //     },
    //     body: JSON.stringify({
    //         ids: [456]
    //     })
    // })
    //     .then(response => response.json())
    //     .then(res => {
    //         console.log(res, 'res');
    //     })
    //     .catch(error => {
    //         console.error('请求出错:', error);
    //     });
  },
  beforeDestroy() {
    // 清理事件监听器
    window.removeEventListener('focus', this.onWindowFocus);
    window.removeEventListener('blur', this.onWindowBlur);
  },
};
</script>
<style lang="scss" scoped>
.login {
  width: 100%;
  height: 100vh;
  background-image: url('~@/assets/login_bg.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .dialog {
    background-color: #ffffff;
    border-radius: 18px;
    background-size: 100% 100%;
    width: 480px;
    height: 340px;
    box-sizing: border-box;
    padding: 30px 48px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .form {
      width: 100%;
    }

    .title {
      font-weight: 500;
      font-size: 30px;
      color: #333333;
      line-height: 42px;
      margin-bottom: 36px;
    }

    .submit {
      margin-top: 24px;
      width: 222px;
      height: 56px;
      text-align: center;
      line-height: 56px;
      // color: #999999;
      border-radius: 18px;
      // background-color: #F7F9FA;
      font-size: 20px;
    }
  }
}

::v-deep .el-button {
  margin-top: 20px !important;
  padding: 14px 120px !important;
  font-size: 20px !important;
  border-radius: 10px !important;
}

/* 强制更新弹窗样式 */
::v-deep .el-dialog__wrapper {
  z-index: 9999 !important;
}

::v-deep .el-dialog {
  border-radius: 8px !important;
}

::v-deep .el-dialog__header {
  background-color: #f5f7fa !important;
  border-bottom: 1px solid #e4e7ed !important;
}

::v-deep .el-dialog__title {
  font-weight: bold !important;
  color: #303133 !important;
}

/* 确保弹窗无法被关闭 */
::v-deep .el-dialog__close {
  display: none !important;
}
</style>
